import Vue from 'vue'
import Vuex from 'vuex'
import Cookies from 'js-cookie'
import routerData from './modules/routerData'
import role from './modules/role'
import layout from './modules/layout/index'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    token: Cookies.get('token'),
    companyId: Cookies.get('companyId'),
    userName: Cookies.get('userName'),
    userId: Cookies.get('userId'),
    lastTime: Cookies.get('lastTime'),
    roles: Cookies.get('roles')
    
  },
  mutations: {
    setToken(state, token) {
      state.token = token
      Cookies.set('token', token, { expires: 24 / 24 });
    },
    refreshToken(state, token) {
      state.refreshToken = token
      Cookies.set('refreshToken', token, { expires: 24 / 24 });
    },
   
    // 用户名
    userName(state, list) {
      state.userName = list;
      Cookies.set('userName', list, { expires: 24 / 24 });
    },
    // 用户ID
    userId(state, list) {
      state.userId = list;
      Cookies.set('userId', list, { expires: 24 / 24 });
    },
    // 用户身份证号
    idNumber(state, list) {
      state.idNumber = list;
      Cookies.set('idNumber', list, { expires: 24 / 24 });
    },
    // 单位ID
    companyId(state, list) {
      state.companyId = list;
      Cookies.set('companyId', list, { expires: 24 / 24 });
    },
    // 单位编码
    companyCode(state, list) {
      state.companyCode = list;
      Cookies.set('companyCode', list, { expires: 24 / 24 });
    },
    // 登录时间
    lastTime(state, list) {
      state.lastTime = list;
      Cookies.set('lastTime', list, { expires: 24 / 24 });
    },
    roles(state, list) {
      state.roles = list;
      Cookies.set('roles', list, { expires: 24 / 24 });
    },
    
  },
  actions: {
    setToken({ commit }, token) {
      return new Promise((resolve, reject) => {
        commit('setToken', token)
        resolve()
      })
    }
  },
  getters: {
    addRouters: state => state.routerData.addRouters,
    token: state => state.token,
    refreshToken: state => state.refreshToken,
    accountNumber: state => state.accountNumber,
    userName: state => state.userName,
    userId: state => state.userId,
    lastTime: state => state.lastTime,
    idNumber: state => state.idNumber,
    companyId: state => state.companyId,
    companyCode: state => state.companyCode,
    info: state => state.role.info,
    roles: state => state.state.roles,
    routers: state => state.routerData.routers,
    logoShow: state => state.layout.logoShow,
    isCollapse: state => state.layout.isCollapse,
    uniquerouter: state => state.layout.uniquerouter,
    tabnavBox: state => state.layout.tabnavBox,
    visible: state => state.layout.visible,
    left: state => state.layout.left,
    top: state => state.layout.top,
    rightNav: state => state.layout.rightNav,
  },
  modules: {
    routerData,
    role,
    layout
  }
})

export default store



// WEBPACK FOOTER //
// ./src/system/index/store/index.js